import { theme } from "src/theme/theme";

const SolveInitialAmountIcon = ({ width = "140", height = "113" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 140 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.1013 97.4328C92.9323 97.4328 114.683 75.6217 114.683 48.7164C114.683 21.8111 92.9323 0 66.1013 0C39.2704 0 17.5195 21.8111 17.5195 48.7164C17.5195 75.6217 39.2704 97.4328 66.1013 97.4328Z"
        fill={theme.colors.primary["500"]}
        fill-opacity="0.1"
      />
      <g filter="url(#filter0_d_11_15497)">
        <path
          d="M80.6204 70.4945L43.5621 85.4661C42.9419 85.6988 42.2441 85.3885 42.0116 84.8455L20.6914 31.8634C20.4588 31.2428 20.7689 30.5446 21.3116 30.3119L58.3699 15.3404C58.9901 15.1077 59.6879 15.418 59.9205 15.961L81.2406 68.8655C81.5507 69.5637 81.2406 70.2618 80.6204 70.4945Z"
          fill="white"
        />
      </g>
      <path
        d="M64.2623 39.1552L33.2511 51.6444C32.941 51.7995 32.6309 51.6444 32.4759 51.3341C32.3208 51.0238 32.4759 50.7135 32.786 50.5584L63.7196 38.0692C64.0297 37.914 64.3398 38.0692 64.4948 38.3795C64.6499 38.6897 64.4948 39 64.2623 39.1552Z"
        fill="#E6ECF5"
      />
      <path
        d="M65.425 42.1806L34.4914 54.6698C34.1813 54.8249 33.8712 54.6698 33.7161 54.3595C33.561 54.0492 33.7161 53.7389 34.0262 53.5838L64.9598 41.0946C65.2699 40.9394 65.58 41.0946 65.7351 41.4048C65.8901 41.7151 65.7351 42.0254 65.425 42.1806Z"
        fill="#E6ECF5"
      />
      <path
        d="M66.6652 45.1284L35.7316 57.6952C35.4215 57.8503 35.1114 57.6952 34.9563 57.3849C34.8013 57.0746 34.9563 56.7643 35.2664 56.6091L66.2 44.1199C66.5101 43.9648 66.8203 44.1199 66.9753 44.4302C67.1304 44.663 66.9753 45.0508 66.6652 45.1284Z"
        fill="#E6ECF5"
      />
      <path
        d="M48.601 55.9887L36.9718 60.7206C36.6617 60.8758 36.3516 60.7206 36.1966 60.4103C36.0415 60.1 36.1966 59.7897 36.5067 59.6346L48.1359 54.9027C48.446 54.7475 48.7561 54.9027 48.9111 55.213C48.9887 55.5232 48.9111 55.8335 48.601 55.9887Z"
        fill="#E6ECF5"
      />
      <path
        opacity="0.3"
        d="M70.6964 52.808L71.7043 55.3679C71.8593 55.8333 71.7043 56.3763 71.2391 56.5315L40.6156 68.9431C40.1505 69.0982 39.6078 68.9431 39.4527 68.4777L38.4449 65.8402C38.2898 65.3748 38.4449 64.8317 38.91 64.6766L69.5335 52.3425C69.9987 52.1874 70.4638 52.4201 70.6964 52.808Z"
        fill="url(#paint0_linear_11_15497)"
      />
      <path
        opacity="0.3"
        d="M73.1001 58.7035L74.108 61.2634C74.263 61.7288 74.108 62.2718 73.6428 62.427L43.0193 74.8386C42.5542 74.9937 42.0115 74.8386 41.8564 74.3732L40.771 71.7357C40.616 71.2703 40.771 70.7273 41.2362 70.5721L71.8597 58.238C72.3249 58.0829 72.8675 58.3156 73.1001 58.7035Z"
        fill="url(#paint1_linear_11_15497)"
      />
      <path
        opacity="0.3"
        d="M75.4259 64.5989L76.4338 67.1588C76.5888 67.6242 76.4338 68.1672 75.9686 68.3224L45.3451 80.734C44.88 80.8891 44.3373 80.734 44.1822 80.2686L43.1744 77.7087C43.0193 77.2432 43.1744 76.7002 43.6395 76.5451L74.263 64.211C74.7282 63.9783 75.2709 64.211 75.4259 64.5989Z"
        fill="url(#paint2_linear_11_15497)"
      />
      <path
        d="M42.0887 63.4355L43.7943 67.702L40.6156 68.9432C40.1505 69.0984 39.6078 68.9432 39.4527 68.4778L38.4449 65.8403C38.2898 65.3749 38.4449 64.8319 38.91 64.6767L42.0887 63.4355Z"
        fill="url(#paint3_linear_11_15497)"
      />
      <path
        d="M41.3142 70.5721L50.6175 66.771L52.3231 71.0375L43.0198 74.8386C42.5546 74.9937 42.0119 74.8386 41.8569 74.3731L40.7715 71.7356C40.6164 71.3478 40.849 70.8048 41.3142 70.5721Z"
        fill="url(#paint4_linear_11_15497)"
      />
      <path
        d="M43.6395 76.4678L44.9575 75.9248L46.6631 80.1913L45.3451 80.7343C44.88 80.8895 44.3373 80.7343 44.1822 80.2689L43.1744 77.709C43.0193 77.2435 43.1744 76.7005 43.6395 76.4678Z"
        fill="url(#paint5_linear_11_15497)"
      />
      <path
        d="M44.1047 36.5175C44.0272 32.251 40.5385 28.7603 36.1969 28.7603H36.1194C31.7778 28.7603 28.2891 32.3286 28.2891 36.6727C28.3666 41.0167 31.9329 44.5075 36.2744 44.5075C38.6778 44.5075 40.771 43.4215 42.2441 41.7925C43.4845 40.3962 44.1823 38.612 44.1823 36.5951C44.1047 36.5951 44.1047 36.5951 44.1047 36.5175ZM36.2744 42.0252C33.3284 42.0252 30.925 39.6204 30.925 36.6727C30.925 33.7249 33.3284 31.3202 36.2744 31.3202H36.352C39.298 31.3202 41.6238 33.6473 41.7014 36.5175C41.7014 36.5951 41.7014 36.5951 41.7014 36.6727C41.7014 37.9914 41.2362 39.2326 40.3834 40.1634C39.298 41.327 37.9025 42.0252 36.2744 42.0252Z"
        fill="#E6EDF5"
      />
      <g filter="url(#filter1_d_11_15497)">
        <path
          d="M44.1051 36.5175H41.5467C41.5467 33.6473 39.1433 31.3202 36.2748 31.3202H36.1973V28.7603H36.2748C40.5388 28.7603 44.0276 32.251 44.1051 36.5175Z"
          fill={theme.colors.primary["500"]}
        />
      </g>
      <g filter="url(#filter2_d_11_15497)">
        <path
          d="M95.7385 82.5183L58.2925 68.5552C57.6723 68.3225 57.3622 67.6243 57.5948 67.0038L77.4419 13.5562C77.6745 12.9356 78.3722 12.6253 78.9925 12.858L116.438 26.7435C117.059 26.9763 117.369 27.6744 117.136 28.295L97.289 81.8201C97.0564 82.4407 96.3587 82.751 95.7385 82.5183Z"
          fill="white"
        />
      </g>
      <path
        opacity="0.4"
        d="M90.7765 36.9054L87.7529 35.7419L90.2338 28.8379L93.2574 29.9239L90.7765 36.9054Z"
        fill="url(#paint6_linear_11_15497)"
      />
      <g filter="url(#filter3_d_11_15497)">
        <path
          d="M94.8853 38.3795L91.7842 37.2159L95.583 26.666L98.6066 27.8296L94.8853 38.3795Z"
          fill="#78B700"
        />
      </g>
      <g filter="url(#filter4_d_11_15497)">
        <path
          d="M103.027 41.2494L100.003 40.1633L104.965 26.2778L108.066 27.3638L103.027 41.2494Z"
          fill="#78B700"
        />
      </g>
      <path
        opacity="0.4"
        d="M106.902 42.6459L103.879 41.5599L105.197 37.7588L108.298 38.9224L106.902 42.6459Z"
        fill="url(#paint7_linear_11_15497)"
      />
      <path
        d="M104.732 48.309L73.4103 36.6731C73.1002 36.5955 72.9452 36.2077 73.0227 35.8974C73.1002 35.5871 73.4879 35.4319 73.798 35.5095L105.119 47.1454C105.429 47.223 105.584 47.6109 105.507 47.9211C105.352 48.2314 105.042 48.3866 104.732 48.309Z"
        fill="#E6ECF5"
      />
      <path
        d="M103.568 51.3339L72.2472 39.698C71.9371 39.6204 71.7821 39.2326 71.8596 38.9223C71.9371 38.612 72.3248 38.4568 72.6349 38.5344L103.956 50.1703C104.266 50.2479 104.421 50.6358 104.344 50.946C104.266 51.2563 103.879 51.4891 103.568 51.3339Z"
        fill="#E6ECF5"
      />
      <path
        d="M102.484 54.3593L71.1623 42.7234C70.8522 42.6458 70.6971 42.258 70.7746 41.9477C70.8522 41.6374 71.2398 41.4822 71.5499 41.5598L102.871 53.1957C103.181 53.2733 103.336 53.6611 103.259 53.9714C103.104 54.3593 102.794 54.5144 102.484 54.3593Z"
        fill="#E6ECF5"
      />
      <path
        d="M81.8606 50.1705L70.0763 45.8264C69.7662 45.7489 69.6112 45.361 69.6887 45.0507C69.7662 44.7404 70.1539 44.5853 70.464 44.6628L82.2482 49.0069C82.5583 49.0845 82.7134 49.4723 82.6358 49.7826C82.4808 50.0929 82.1707 50.2481 81.8606 50.1705Z"
        fill="#DDDDDD"
      />
      <path
        opacity="0.3"
        d="M100.313 62.7371L99.3827 65.3745C99.2277 65.84 98.685 66.0727 98.2198 65.9175L91.5524 63.4352L67.2087 54.3592C66.7435 54.2041 66.5109 53.6611 66.666 53.1956L67.5963 50.5582C67.7514 50.0927 68.2941 49.86 68.7593 50.0152L92.9479 59.0136L99.6928 61.4959C100.236 61.8062 100.468 62.2716 100.313 62.7371Z"
        fill="url(#paint8_linear_11_15497)"
      />
      <path
        opacity="0.3"
        d="M98.0646 68.7103L97.1343 71.3477C96.9792 71.8132 96.4366 72.0459 95.9714 71.8908L93.7231 71.0375L65.0378 60.41C64.5726 60.2549 64.34 59.7118 64.4951 59.2464L65.4254 56.6089C65.5805 56.1435 66.1232 55.9108 66.5884 56.0659L95.3512 66.771L97.5219 67.6243C97.9871 67.7794 98.2197 68.2448 98.0646 68.7103Z"
        fill="url(#paint9_linear_11_15497)"
      />
      <path
        opacity="0.3"
        d="M95.8937 74.6834L94.9634 77.3209C94.8083 77.7863 94.2657 78.019 93.8005 77.8639L82.3264 73.5974L62.8669 66.3831C62.4017 66.228 62.1691 65.685 62.3242 65.2196L63.2545 62.5821C63.4096 62.1167 63.9523 61.8839 64.4175 62.0391L84.3421 69.4085L95.351 73.5198C95.8162 73.675 96.0488 74.218 95.8937 74.6834Z"
        fill="url(#paint10_linear_11_15497)"
      />
      <path
        d="M64.4175 62.0388L84.3421 69.4082L82.3264 73.5196L62.8669 66.3053C62.4017 66.1502 62.1691 65.6072 62.3242 65.1417L63.2545 62.5043C63.4096 62.1164 63.9523 61.8837 64.4175 62.0388Z"
        fill="url(#paint11_linear_11_15497)"
      />
      <path
        d="M66.666 53.2733L67.5963 50.6358C67.7514 50.1704 68.2941 49.9376 68.7593 50.0928L92.9479 59.0912L91.3974 63.3577L67.2087 54.3593C66.7435 54.2041 66.5109 53.7387 66.666 53.2733Z"
        fill="url(#paint12_linear_11_15497)"
      />
      <path
        d="M95.3512 66.771L93.7231 71.0375L65.0378 60.41C64.5726 60.2549 64.34 59.7118 64.4951 59.2464L65.4254 56.6089C65.5805 56.1435 66.1232 55.9108 66.5884 56.0659L95.3512 66.771Z"
        fill="url(#paint13_linear_11_15497)"
      />
      <path
        d="M74.5738 52.2648L73.0233 56.5313L67.2087 54.3592C66.7435 54.2041 66.5109 53.6611 66.666 53.1956L67.5963 50.5582C67.7514 50.0927 68.2941 49.86 68.7593 50.0152L74.5738 52.2648Z"
        fill="#DDDDDD"
      />
      <path
        d="M66.5884 56.0662L72.4029 58.2382L70.8524 62.5047L65.0378 60.3327C64.5726 60.1775 64.34 59.6345 64.4951 59.1691L65.4254 56.5316C65.658 56.1437 66.1232 55.911 66.5884 56.0662Z"
        fill="#DDDDDD"
      />
      <path
        d="M64.4175 62.0388L70.232 64.2109L68.6815 68.4774L62.8669 66.3053C62.4017 66.1502 62.1691 65.6072 62.3242 65.1417L63.2545 62.5043C63.4096 62.1164 63.9523 61.8837 64.4175 62.0388Z"
        fill="#DDDDDD"
      />
      <g filter="url(#filter5_d_11_15497)">
        <path
          d="M89.0712 69.5637H49.1444C48.5241 69.5637 47.9814 69.0207 47.9814 68.4001V11.3067C47.9814 10.6861 48.5241 10.1431 49.1444 10.1431H89.0712C89.6914 10.1431 90.2341 10.6861 90.2341 11.3067V68.3226C90.3116 69.0207 89.7689 69.5637 89.0712 69.5637Z"
          fill="white"
        />
      </g>
      <path
        d="M85.5822 32.0954H52.2452C51.9351 32.0954 51.625 31.8628 51.625 31.4752C51.625 31.1651 51.8576 30.855 52.2452 30.855H85.5822C85.8923 30.855 86.2024 31.0876 86.2024 31.4752C86.2024 31.7853 85.8923 32.0954 85.5822 32.0954Z"
        fill="#E6ECF5"
      />
      <path
        d="M85.5822 35.2756H52.2452C51.9351 35.2756 51.625 35.043 51.625 34.6554C51.625 34.3453 51.8576 34.0352 52.2452 34.0352H85.5822C85.8923 34.0352 86.2024 34.2677 86.2024 34.6554C86.2024 35.043 85.8923 35.2756 85.5822 35.2756Z"
        fill="#E6ECF5"
      />
      <path
        d="M85.5822 38.5339H52.2452C51.9351 38.5339 51.625 38.3013 51.625 37.9137C51.625 37.6036 51.8576 37.2935 52.2452 37.2935H85.5822C85.8923 37.2935 86.2024 37.526 86.2024 37.9137C86.2024 38.3013 85.8923 38.5339 85.5822 38.5339Z"
        fill="#E6ECF5"
      />
      <path
        d="M85.5053 50.7126H74.2638C73.9537 50.7126 73.6436 50.48 73.6436 50.0924C73.6436 49.7823 73.8761 49.4722 74.2638 49.4722H85.5053C85.8154 49.4722 86.1255 49.7048 86.1255 50.0924C86.048 50.4025 85.8154 50.7126 85.5053 50.7126Z"
        fill="#E6ECF5"
      />
      <path
        d="M67.3635 54.0493C67.286 49.7828 63.7972 46.292 59.4557 46.292H59.3782C55.0366 46.292 51.5479 49.8603 51.5479 54.2044C51.5479 58.5485 55.1141 62.1168 59.4557 62.1168C61.859 62.1168 63.9523 61.0308 65.4253 59.4018C66.6658 58.0055 67.3635 56.2213 67.3635 54.2044C67.3635 54.1268 67.3635 54.0493 67.3635 54.0493ZM59.4557 59.4794C56.5096 59.4794 54.1063 57.0746 54.1063 54.1268C54.1063 51.1791 56.5096 48.7743 59.4557 48.7743H59.5332C62.4793 48.7743 64.8051 51.1015 64.8826 53.9717C64.8826 54.0493 64.8826 54.0493 64.8826 54.1268C64.8826 55.4456 64.4175 56.6867 63.5647 57.6176C62.4793 58.7812 61.0838 59.4794 59.4557 59.4794Z"
        fill="#E6EDF5"
      />
      <path
        d="M67.3633 54.0493H64.8049C64.7273 51.1791 62.4015 48.8519 59.4555 48.8519H59.3779V46.292H59.4555C63.797 46.292 67.2858 49.7052 67.3633 54.0493Z"
        fill="url(#paint14_linear_11_15497)"
      />
      <path
        d="M67.3637 54.1269C67.3637 56.1438 66.6659 57.9279 65.4255 59.3243L63.4873 57.6952C64.3401 56.7644 64.8053 55.5232 64.8053 54.2045C64.8053 54.1269 64.8053 54.1269 64.8053 54.0493H67.3637V54.1269Z"
        fill="url(#paint15_linear_11_15497)"
      />
      <path
        d="M71.5501 50.9463C72.0211 50.9463 72.4029 50.5643 72.4029 50.093C72.4029 49.6218 72.0211 49.2397 71.5501 49.2397C71.0791 49.2397 70.6973 49.6218 70.6973 50.093C70.6973 50.5643 71.0791 50.9463 71.5501 50.9463Z"
        fill="#E6ECF5"
      />
      <path
        d="M85.5053 54.281H74.2638C73.9537 54.281 73.6436 54.0484 73.6436 53.6607C73.6436 53.3506 73.8761 53.0405 74.2638 53.0405H85.5053C85.8154 53.0405 86.1255 53.2731 86.1255 53.6607C86.048 53.9709 85.8154 54.281 85.5053 54.281Z"
        fill="#E6ECF5"
      />
      <path
        d="M71.5501 54.5147C72.0211 54.5147 72.4029 54.1327 72.4029 53.6614C72.4029 53.1901 72.0211 52.8081 71.5501 52.8081C71.0791 52.8081 70.6973 53.1901 70.6973 53.6614C70.6973 54.1327 71.0791 54.5147 71.5501 54.5147Z"
        fill="url(#paint16_linear_11_15497)"
      />
      <path
        d="M85.5053 57.8493H74.2638C73.9537 57.8493 73.6436 57.6168 73.6436 57.2291C73.6436 56.919 73.8761 56.6089 74.2638 56.6089H85.5053C85.8154 56.6089 86.1255 56.8415 86.1255 57.2291C86.048 57.5392 85.8154 57.8493 85.5053 57.8493Z"
        fill="#E6ECF5"
      />
      <path
        d="M71.5501 58.0831C72.0211 58.0831 72.4029 57.701 72.4029 57.2298C72.4029 56.7585 72.0211 56.3765 71.5501 56.3765C71.0791 56.3765 70.6973 56.7585 70.6973 57.2298C70.6973 57.701 71.0791 58.0831 71.5501 58.0831Z"
        fill="url(#paint17_linear_11_15497)"
      />
      <path
        d="M51.8574 27.8298H86.1247V13.9443L80.6978 16.6594L77.8292 18.6763L72.7124 18.5987L68.2158 20.9259L64.3394 21.4689L62.9439 23.0203L58.9125 25.5802L54.9585 26.2784L51.8574 27.8298Z"
        fill="#FEBC59"
      />
      <path
        d="M51.8574 27.8297H86.1247V17.2798L80.6978 19.2967L77.8292 20.8481L72.7124 20.7706L68.2158 22.5547L64.3394 23.0202L62.9439 24.1062L58.9125 26.1231L54.9585 26.6661L51.8574 27.8297Z"
        fill="#E6EDF5"
      />
      <path
        d="M51.8574 27.8295H86.1247V21.8564L80.6978 23.02L77.8292 23.8733H72.7124L68.2158 24.8042L64.3394 25.1145L62.9439 25.7351L58.9125 26.8211L54.9585 27.1314L51.8574 27.8295Z"
        fill="#CED7E2"
      />
      <g filter="url(#filter6_d_11_15497)">
        <path
          d="M116.108 51.4985L109.574 80.6066C109.166 82.3101 107.124 83.6433 104.674 83.6433H34.0263C31.5761 83.6433 29.5343 82.3842 29.1259 80.6066L23.8172 56.7573C23.4088 54.9797 25.3485 53.2761 27.9008 53.2761H67.7166C68.9417 53.2761 69.9626 52.6836 70.371 51.8689L71.494 49.3506C71.9024 48.5359 72.9233 47.9434 74.1484 47.9434H112.127C114.577 48.0174 116.516 49.6469 116.108 51.4985Z"
          fill="white"
        />
      </g>
      <path
        d="M118.276 42.8931L110.994 87.5125C110.539 90.1238 108.264 92.1674 105.533 92.1674H26.8014C24.0708 92.1674 21.7953 90.2373 21.3402 87.5125L15.424 50.9541C14.9689 48.2292 17.1306 45.6179 19.9749 45.6179H64.3469C65.7122 45.6179 66.8499 44.7096 67.305 43.4607L68.5566 39.6005C69.0117 38.3516 70.1494 37.4434 71.5147 37.4434H113.839C116.569 37.5569 118.731 40.0547 118.276 42.8931Z"
        fill="white"
      />
      <path
        d="M53.4483 60.2599H28.8731C28.418 60.2599 27.9629 59.9193 27.9629 59.3516C27.9629 58.784 28.3042 58.4434 28.8731 58.4434H53.5621C54.0172 58.4434 54.4723 58.784 54.4723 59.3516C54.4723 59.9193 54.0172 60.2599 53.4483 60.2599Z"
        fill="#E6EDF5"
      />
      <path
        d="M45.2565 65.5959H30.4659C30.0108 65.5959 29.5557 65.2553 29.5557 64.6876C29.5557 64.1199 29.897 63.7793 30.4659 63.7793H45.2565C45.7116 63.7793 46.1667 64.1199 46.1667 64.6876C46.1667 65.2553 45.7116 65.5959 45.2565 65.5959Z"
        fill="#E6EDF5"
      />
      <path
        d="M85.9847 85.5573C85.9847 86.5375 85.887 87.4197 85.7892 88.3999C84.8117 94.8693 80.413 100.162 74.4502 102.417C72.3975 103.201 70.247 103.593 67.9987 103.593C61.7427 103.593 56.171 100.358 52.9452 95.4574C51.0879 92.6148 50.0127 89.1841 50.0127 85.5573C50.0127 75.5592 58.0282 67.5215 67.9987 67.5215C77.8715 67.5215 85.9847 75.6572 85.9847 85.5573Z"
        fill="url(#paint18_linear_11_15497)"
      />
      <path
        d="M75.5477 89.3017C75.5477 89.9065 75.4627 90.5113 75.2926 91.1161C75.1225 91.7209 74.839 92.2879 74.4421 92.8171C74.0452 93.3274 73.516 93.781 72.8545 94.1779C72.2119 94.5559 71.4181 94.8394 70.4731 95.0283V97.6082C70.4731 97.7594 70.4164 97.8917 70.303 98.0051C70.1896 98.1185 70.0573 98.1752 69.9061 98.1752H67.3262C67.175 98.1752 67.0427 98.1185 66.9293 98.0051C66.8159 97.8917 66.7592 97.7594 66.7592 97.6082V95.1984C66.0221 95.1606 65.3512 95.0945 64.7464 95C64.1605 94.9244 63.6029 94.8299 63.0737 94.7165C62.9225 94.6787 62.7902 94.6126 62.6768 94.5181C62.5823 94.4236 62.5351 94.3007 62.5351 94.1495V92.1083C62.5351 91.9571 62.5823 91.8343 62.6768 91.7398C62.7902 91.6264 62.9225 91.5697 63.0737 91.5697H63.1304C63.4139 91.6075 63.7825 91.6453 64.2361 91.6831C64.7086 91.702 65.1905 91.7303 65.6819 91.7681C66.1733 91.787 66.6364 91.8059 67.0711 91.8248C67.5247 91.8437 67.8838 91.8532 68.1484 91.8532C69.4147 91.8532 70.2746 91.6358 70.7282 91.2011C71.2007 90.7664 71.437 90.1333 71.437 89.3017C71.437 89.0182 71.3992 88.7725 71.3236 88.5646C71.248 88.3378 71.1157 88.1204 70.9267 87.9125C70.7377 87.7046 70.492 87.4967 70.1896 87.2888C69.8872 87.062 69.4997 86.8069 69.0272 86.5234L65.285 84.2837C64.6235 83.8868 64.0754 83.4899 63.6407 83.093C63.2249 82.6961 62.8847 82.2898 62.6201 81.874C62.3744 81.4393 62.1949 80.9951 62.0815 80.5415C61.987 80.069 61.9397 79.5871 61.9397 79.0957C61.9397 78.4531 62.0248 77.8483 62.1949 77.2813C62.365 76.6954 62.639 76.1756 63.017 75.722C63.395 75.2684 63.8864 74.8904 64.4912 74.588C65.1149 74.2667 65.8709 74.0305 66.7592 73.8793V71.4979C66.7592 71.3467 66.8159 71.2144 66.9293 71.101C67.0427 70.9876 67.175 70.9309 67.3262 70.9309H69.9061C70.0573 70.9309 70.1896 70.9876 70.303 71.101C70.4164 71.2144 70.4731 71.3467 70.4731 71.4979V73.7659C71.2669 73.8037 72.0323 73.8698 72.7694 73.9643C73.5254 74.0399 74.0924 74.125 74.4704 74.2195C74.6216 74.2573 74.7445 74.3234 74.839 74.4179C74.9335 74.4935 74.9807 74.6069 74.9807 74.7581V76.856C74.9807 77.0072 74.9335 77.1301 74.839 77.2246C74.7634 77.3191 74.65 77.3663 74.4988 77.3663H74.4421C73.4971 77.2718 72.5615 77.2057 71.6354 77.1679C70.7093 77.1112 69.7832 77.0828 68.8571 77.0828C67.7987 77.0828 67.0333 77.2624 66.5608 77.6215C66.1072 77.9617 65.8804 78.4531 65.8804 79.0957C65.8804 79.3225 65.9087 79.5398 65.9654 79.7477C66.041 79.9367 66.1639 80.1352 66.334 80.3431C66.523 80.5321 66.7687 80.7305 67.0711 80.9384C67.3735 81.1463 67.7515 81.3731 68.2051 81.6188L71.6071 83.5183C72.382 83.953 73.0246 84.3971 73.5349 84.8507C74.0452 85.2854 74.4421 85.739 74.7256 86.2115C75.028 86.684 75.2359 87.1754 75.3493 87.6857C75.4816 88.196 75.5477 88.7347 75.5477 89.3017Z"
        fill="white"
      />
      <path
        d="M117.323 28.0341C119.374 28.0341 121.037 26.3664 121.037 24.3093C121.037 22.2521 119.374 20.5845 117.323 20.5845C115.271 20.5845 113.608 22.2521 113.608 24.3093C113.608 26.3664 115.271 28.0341 117.323 28.0341Z"
        fill="#78B700"
        fill-opacity="0.1"
      />
      <path
        d="M19.6703 14.507C21.02 14.507 22.1141 13.4099 22.1141 12.0565C22.1141 10.7031 21.02 9.60596 19.6703 9.60596C18.3207 9.60596 17.2266 10.7031 17.2266 12.0565C17.2266 13.4099 18.3207 14.507 19.6703 14.507Z"
        fill="#78B700"
        fill-opacity="0.1"
      />
      <path
        d="M8.62464 20.6823C9.5424 20.6823 10.2864 19.9363 10.2864 19.016C10.2864 18.0957 9.5424 17.3496 8.62464 17.3496C7.70688 17.3496 6.96289 18.0957 6.96289 19.016C6.96289 19.9363 7.70688 20.6823 8.62464 20.6823Z"
        fill="#78B700"
        fill-opacity="0.1"
      />
      <path
        d="M113.022 12.2524C113.886 12.2524 114.586 11.5502 114.586 10.6841C114.586 9.81789 113.886 9.11572 113.022 9.11572C112.158 9.11572 111.458 9.81789 111.458 10.6841C111.458 11.5502 112.158 12.2524 113.022 12.2524Z"
        fill="#78B700"
        fill-opacity="0.1"
      />
      <path
        d="M119.278 63.3212C120.142 63.3212 120.842 62.6191 120.842 61.7529C120.842 60.8867 120.142 60.1846 119.278 60.1846C118.414 60.1846 117.714 60.8867 117.714 61.7529C117.714 62.6191 118.414 63.3212 119.278 63.3212Z"
        fill="#EAEEF9"
      />
      <defs>
        <filter
          id="filter0_d_11_15497"
          x="2.90329"
          y="6.40721"
          width="96.169"
          height="105.702"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.85499" />
          <feGaussianBlur stdDeviation="8.85499" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_15497"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_15497"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_11_15497"
          x="25.9773"
          y="24.9278"
          width="28.3482"
          height="28.1973"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.3875" />
          <feGaussianBlur stdDeviation="5.11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_15497"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_15497"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_11_15497"
          x="39.8076"
          y="3.92577"
          width="95.1153"
          height="105.235"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.85499" />
          <feGaussianBlur stdDeviation="8.85499" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_15497"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_15497"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_11_15497"
          x="81.5642"
          y="22.8335"
          width="27.2623"
          height="32.1534"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.3875" />
          <feGaussianBlur stdDeviation="5.11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_15497"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_15497"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_11_15497"
          x="89.7829"
          y="22.4453"
          width="28.5025"
          height="35.4117"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.3875" />
          <feGaussianBlur stdDeviation="5.11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_15497"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_15497"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_11_15497"
          x="30.2715"
          y="1.28807"
          width="77.6797"
          height="94.8409"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.85499" />
          <feGaussianBlur stdDeviation="8.85499" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_15497"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_15497"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_11_15497"
          x="0.662712"
          y="6.99339"
          width="138.6"
          height="81.9002"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-17.85" />
          <feGaussianBlur stdDeviation="11.55" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_15497"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_15497"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_11_15497"
          x1="38.35"
          y1="60.648"
          x2="71.7885"
          y2="60.648"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11_15497"
          x1="40.7282"
          y1="66.542"
          x2="74.1667"
          y2="66.542"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11_15497"
          x1="43.1059"
          y1="72.4359"
          x2="76.5445"
          y2="72.4359"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11_15497"
          x1="38.35"
          y1="66.2296"
          x2="43.805"
          y2="66.2296"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11_15497"
          x1="40.7286"
          y1="70.8598"
          x2="52.2685"
          y2="70.8598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11_15497"
          x1="43.1059"
          y1="78.3932"
          x2="46.6781"
          y2="78.3932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_11_15497"
          x1="87.7279"
          y1="32.8528"
          x2="93.2906"
          y2="32.8528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_11_15497"
          x1="103.859"
          y1="40.2323"
          x2="108.284"
          y2="40.2323"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_11_15497"
          x1="66.6408"
          y1="58.0025"
          x2="100.339"
          y2="58.0025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF66A9" />
          <stop offset="1" stop-color="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_11_15497"
          x1="64.4277"
          y1="63.9602"
          x2="98.1255"
          y2="63.9602"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF66A9" />
          <stop offset="1" stop-color="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_11_15497"
          x1="62.214"
          y1="69.9189"
          x2="95.9138"
          y2="69.9189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF66A9" />
          <stop offset="1" stop-color="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_11_15497"
          x1="62.214"
          y1="67.761"
          x2="84.2952"
          y2="67.761"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF66A9" />
          <stop offset="1" stop-color="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_11_15497"
          x1="66.6408"
          y1="56.7329"
          x2="93.0302"
          y2="56.7329"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF66A9" />
          <stop offset="1" stop-color="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_11_15497"
          x1="64.4277"
          y1="63.5076"
          x2="95.3333"
          y2="63.5076"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF66A9" />
          <stop offset="1" stop-color="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_11_15497"
          x1="59.4127"
          y1="50.1369"
          x2="67.3326"
          y2="50.1369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF66A9" />
          <stop offset="1" stop-color="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_11_15497"
          x1="63.4895"
          y1="56.6659"
          x2="67.3355"
          y2="56.6659"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_11_15497"
          x1="70.7514"
          y1="53.6585"
          x2="72.4021"
          y2="53.6585"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF66A9" />
          <stop offset="1" stop-color="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_11_15497"
          x1="70.7514"
          y1="57.2326"
          x2="72.4021"
          y2="57.2326"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83A6FF" />
          <stop offset="1" stop-color="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_11_15497"
          x1="67.9987"
          y1="67.5215"
          x2="67.9987"
          y2="103.593"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0208333" stop-color="#FFC46B" />
          <stop offset="1" stop-color="#F79B11" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SolveInitialAmountIcon;
